import React from 'react';
import { media } from '../../server';
import { useStateContext } from '../../context/ContextProvider';
import Button from '../layout/Button';
import { Link } from "react-router-dom";
import { IoArrowForwardOutline, IoArrowBackOutline } from 'react-icons/io5';
import { useTranslation } from 'react-i18next';
import { renderText, truncateText } from '../hooks/TextVeiw';
import { truncateTitle } from '../../middleware/truncateTitle';
import { motion } from 'framer-motion';
import { FaUtensils, FaStar } from 'react-icons/fa';

function MealCategoryCard({ category, index = 0 }) {
  const { currentDir, currentLang } = useStateContext();
  const { t } = useTranslation();
  const IsArabic = currentLang === "ar";

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      viewport={{ once: true }}
      whileHover={{ y: -8 }}
      className="group relative"
    >
      <div className='relative flex min-h-[28rem] rounded-2xl mx-auto gap-5 flex-col items-start bg-white dark:bg-back-darktertiary shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100 dark:border-gray-800 hover:border-color-1 dark:hover:border-color-1'>
        
        {/* Image Container with Overlay */}
        <div className="relative w-full h-56 overflow-hidden">
          <img 
            src={`${media}${category?.Image}`}  
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" 
            alt={currentDir === "ltr" ? category.titleEn : category.titleAr}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          
          {/* Badge */}
          <div className="absolute top-3 right-3 bg-color-1 text-white text-xs font-kufi px-3 py-1 rounded-full shadow-lg">
            {t("Category")}
          </div>
        </div>
        
        {/* Content */}
        <div className="w-full px-5 pb-5 flex flex-col gap-3">
          <h3 className="font-bold font-kufi text-xl text-gray-800 dark:text-gray-100 line-clamp-1 group-hover:text-color-1 transition-colors">
            {currentDir === "ltr" 
              ? truncateTitle(category.titleEn, 4) 
              : truncateTitle(category.titleAr, 4)}
          </h3>
          
          <p className="body-2 text-gray-500 dark:text-gray-400 line-clamp-2 min-h-[3rem]">
            {renderText(
              truncateText(
                currentDir === "ltr" ? category.textEn : category.textAr,
                20
              )
            )}
          </p>
          
          {/* Divider with Icon */}
          <div className="relative flex items-center justify-center my-2">
            <div className="border-t border-gray-200 dark:border-gray-700 w-full"></div>
            <div className="absolute bg-white dark:bg-back-darktertiary px-3">
              <FaUtensils className="text-color-1 text-sm" />
            </div>
          </div>
          
          {/* Button */}
          <Link
            to={`/AllMeals`}
            state={{ category: category }}
            onClick={() => window.scrollTo(0, 0)}
            className="mt-2"
          >
            <Button 
              text={t('View Meals')} 
              Transform={true} 
              nonBackground={true} 
              textStyle={"font-kufi text-sm font-semibold"}  
              textColor={"text-color-1 hover:text-color-1/80"} 
              icon={currentDir === "ltr" ? <IoArrowForwardOutline /> : <IoArrowBackOutline />}
              iconPosition={currentDir === "ltr" ? "right" : "left"}
            />
          </Link>
        </div>
      </div>
    </motion.div>
  );
}

export default MealCategoryCard;